import { render, staticRenderFns } from "./PageletText.vue?vue&type=template&id=2206d8d8&scoped=true&lang=pug"
import script from "./PageletText.vue?vue&type=script&lang=js"
export * from "./PageletText.vue?vue&type=script&lang=js"
import style0 from "./PageletText.vue?vue&type=style&index=0&id=2206d8d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206d8d8",
  null
  
)

export default component.exports